<template>
  <el-main>
    <div
      id="appList"
      :thirdNavigationState="thirdNavigationState"
      :thirdNavigationType="thirdNavigationType"
      :thirdNavigationIdentify="thirdNavigationIdentify"
      :thirdNavigationSearch="thirdNavigationSearch"
    >
      <!-- :dataClone="dataClone" -->
      <section class="con-wrapper" :MyProjectsAddState="MyProjectsAddState">
        <div class="cust-dialog">
          <el-dialog
            :title="$t('botApp.AddNewProject',{contentType:$t('botApp.' + this.form.contentType)})"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleClose"
          >
            <el-form
              :model="form"
              :rules="rules"
              ref="form"
              :show-message="false"
              :hide-required-asterisk="true"
              label-position="top"
            >
              <el-form-item label="temp" prop="projectName">
                <span slot="label">
                  {{$t('botApp.createModal.title')}}&nbsp;
                  <el-tooltip :content="$t('botApp.createModal.title.tooltip',{contentType:$t('botApp.' + this.form.contentType)})" placement="bottom" effect="light">
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </span>
                <el-input v-model="form.projectName"></el-input>
              </el-form-item>
              <!-- <el-form-item label="temp" prop="package">
                <span slot="label">
                  {{$t('botApp.createModal.package')}}&nbsp;
                  <el-tooltip :content="$t('botApp.createModal.package.tooltip')" placement="bottom" effect="light">
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </span>
                <el-input v-model="form.package"></el-input>
              </el-form-item> -->
              <!-- <el-form-item label="temp" prop="publishSecret">
                <span slot="label">
                  {{$t('botApp.createModal.publishSecret')}}&nbsp;
                  <el-tooltip :content="$t('botApp.createModal.publishSecret.tooltip')" placement="bottom" effect="light">
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </span>
                <el-input v-model="form.publishSecret"></el-input>
              </el-form-item> -->
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="resetForm('form')">{{$t('botApp.common.cancel')}}</el-button>
              <el-button type="primary" @click="submitForm('form')">{{$t('botApp.common.create')}}</el-button>
            </span>
          </el-dialog>
        </div>

        <div class="appListBox" v-if="!isTable">
          <el-table
            ref="dataTable"
            id="tableD"
            v-loading="loading"
            :data="appList"
            :header-cell-style="tableHeaderColor"
            :cell-style="cellStyle"
            @row-click="rowClick"
            @cell-click="cellClick"
            style="width: 100%"
          >
            <el-table-column
            prop="icon"
            >
              <template slot-scope="scope">
                <div>
                  <img :src=" iconFunc(scope.row.icon) " alt class="tableIconClass">
                </div>
              </template>
            </el-table-column>

            <el-table-column
              :default-sort="{ prop: 'projectName', order: 'descending' }"
              sortable
              :label="$t('table.common.projectName')"
              width="277px;"
              prop="projectName"
            ></el-table-column>

            <el-table-column
              :default-sort="{ prop: 'contentType', order: 'descending' }"
              sortable
              :label="$t('table.common.projectType')"
              width="154px;"
              prop="contentType"
            ></el-table-column>

            <el-table-column
               sortable
              :default-sort="{ prop: 'updatedAt', order: 'descending' }"
              :label="$t('myprojectsList.table.header.update')"
              prop="updatedAt"
            >
              <template slot-scope="scope">
                <span>{{ momentConversion(scope.row) }}</span>
              </template>
            </el-table-column>

            <el-table-column
              :default-sort="{ prop: 'downloadSum', order: 'ascending' }"
              sortable
              :label="$t('myprojectsList.table.header.version')"
              prop="downloadSum"
              :tooltip-effect="'light'"
            >
              <template slot-scope="scope">
                <div>
                  <span style="display:inline-block;">{{ maxVersionText(scope.row) }}</span>
                  <div>
                    <el-tooltip
                      transition="el-fade-in"
                      popper-class="tooltipItem"
                      effect="light"
                      placement="bottom"
                      v-if="scope.row.notificationMessage"
                    >
                      <div slot="content">
                        <!-- <span>{{ $t(`${scope.row.notificationMessage ? scope.row.notificationMessage.displayI18n : 'noti' }`) }}</span> -->
                        <span>{{ scope.row.notificationMessage ? scope.row.notificationMessage : $t('common.table.tooltip.message.prompt') }}</span>
                      </div>
                      <span
                        :class=" scope.row.maxStatus.style "
                        class="statusAppListClass"
                      >{{ $t(scope.row.maxStatus.displayI18n) }}</span>
                    </el-tooltip>
                    <span
                        v-if="!scope.row.notificationMessage"
                        :class=" scope.row.maxStatus.style "
                        class="statusAppListClass"
                      >{{ $t(scope.row.maxStatus.displayI18n) }}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </section>
      <div v-if="isTable" class="noAppListBox">
        <!-- <div class="noAppListPosi">
          <div class="noAppListBoxDiv">
            <p>{{ $t('myprojectList.table.null.top') }}</p>
            <p>{{ $t('myprojectList.table.null.bottom') }}</p>
          </div>
          <svg
            width="500px"
            height="200px"
            viewBox="0 0 500 200"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
           >
            <title>9DC11365-1F4E-4644-A839-260B20E1AB4F</title>
            <desc>Created with sketchtool.</desc>
            <defs>
              <path
                d="M66.3096532,14.8420133 C66.3096532,14.8420133 56.6494744,25.7612293 38.9947552,26.0794783 C17.5384896,26.466255 7.47457627,9.95266272 3,2"
                id="path-1"
              ></path>
              <filter
                x="-21.1%"
                y="-30.6%"
                width="129.7%"
                height="176.2%"
                filterUnits="objectBoundingBox"
                id="filter-2"
              >
                <feMorphology
                  radius="1"
                  operator="dilate"
                  in="SourceAlpha"
                  result="shadowSpreadOuter1"
                ></feMorphology>
                <feOffset dx="-4" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
                <feMorphology radius="1" operator="erode" in="SourceAlpha" result="shadowInner"></feMorphology>
                <feOffset dx="-4" dy="2" in="shadowInner" result="shadowInner"></feOffset>
                <feComposite
                  in="shadowOffsetOuter1"
                  in2="shadowInner"
                  operator="out"
                  result="shadowOffsetOuter1"
                ></feComposite>
                <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                <feColorMatrix
                  values="0 0 0 0 0   0 0 0 0 0.561   0 0 0 0 0.667  0 0 0 0.188405797 0"
                  type="matrix"
                  in="shadowBlurOuter1"
                ></feColorMatrix>
              </filter>
              <polyline
                id="path-3"
                points="1.49949973 1.70671545 1.49949973 7.70671545 7.49949973 7.70671545"
              ></polyline>
              <filter
                x="-91.7%"
                y="-125.0%"
                width="433.3%"
                height="416.7%"
                filterUnits="objectBoundingBox"
                id="filter-4"
              >
                <feMorphology
                  radius="1"
                  operator="dilate"
                  in="SourceAlpha"
                  result="shadowSpreadOuter1"
                ></feMorphology>
                <feOffset dx="5" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
                <feMorphology radius="1" operator="erode" in="SourceAlpha" result="shadowInner"></feMorphology>
                <feOffset dx="5" dy="2" in="shadowInner" result="shadowInner"></feOffset>
                <feComposite
                  in="shadowOffsetOuter1"
                  in2="shadowInner"
                  operator="out"
                  result="shadowOffsetOuter1"
                ></feComposite>
                <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                <feColorMatrix
                  values="0 0 0 0 0   0 0 0 0 0.561   0 0 0 0 0.667  0 0 0 0.188405797 0"
                  type="matrix"
                  in="shadowBlurOuter1"
                ></feColorMatrix>
              </filter>
            </defs>
            <g
              id="DC2.0_My-Projects"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
              stroke-linecap="round"
            >
              <g id="DC2.0_My-Projects_empty" transform="translate(-390.000000, -319.000000)">
                <g id="placeholder" transform="translate(390.000000, 319.000000)">
                  <g id="Group-4">
                    <g
                      id="Group-2"
                      transform="translate(389.715335, 95.629480) scale(-1, 1) rotate(7.000000) translate(-389.715335, -95.629480) translate(356.215335, 82.129480)"
                    >
                      <g id="Path-2">
                        <use
                          fill="black"
                          fill-opacity="1"
                          filter="url(#filter-2)"
                          xlink:href="#path-1"
                        ></use>
                        <use stroke="#008FAA" stroke-width="2" xlink:href="#path-1"></use>
                      </g>
                      <g
                        id="Path-3"
                        transform="translate(4.499500, 4.706715) rotate(-253.000000) translate(-4.499500, -4.706715) "
                      >
                        <use
                          fill="black"
                          fill-opacity="1"
                          filter="url(#filter-4)"
                          xlink:href="#path-3"
                        ></use>
                        <use stroke="#008FAA" stroke-width="2" xlink:href="#path-3"></use>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </div> -->
        <div style="width: 500px;margin: auto;font-size: 14px; text-align: center;margin-top: 82px;">
            <!-- ../assets/img/header/nuwa_developer_infobox.png -->
            <div style="width: 102px;height: 102px;margin: auto;">
                <div style="width: 102px;display: table-cell;vertical-align: middle;height: 102px;text-align: center;">
                    <img src="../../../assets/img/header/nuwa_developer_infobox.png" alt="">
                </div>
            </div>
            <p style="margin-bottom: 3px;">{{ $t('myprojectList.table.null.test.top') }}</p>
            <p>{{ $t('myprojectList.table.null.test.bottom') }}</p>
        </div>
      </div>
    </div>
  </el-main>
</template>

<script>
import api from '../../../api'
import apiConfig from '../../../api/apiConfig'
import _ from 'lodash'
// fu
import moment from 'moment'
export default {
    data () {
        return {
            loading: false,
            appList: [],
            appListClone: [],
            dialogVisible: false,
            form: {
                projectName: '',
                // apkName: '',
                // secureCode: '',
                // majorMarket: ''
                // package: '',
                // keyName: '',
                platform: 'android',
                // publishSecret: '',
                contentType: ''
                // testSecret: '',
                // mainMarket: ''
            },

            formLabelWidth: '120px',
            markets: [],
            rules: {
                projectName: [{ required: true, trigger: 'blur' }]
                // package: [{ required: true, trigger: 'blur' }],
                // publishSecret: [{ required: true, trigger: 'blur' }]
            },
            isTable: false
        }
    },
    mounted () {
        this.pubMarkets()
        this.getAppList()
    },
    methods: {
        // fu
        isScrollShowFunc (len) {
            if (len > 9) {
                // this.$nextTick(() => {
                this.$refs.dataTable.$el
                    .querySelector('.el-table__body-wrapper')
                    .classList.add('scrollShow')
                // })
            } else {
                this.$refs.dataTable.$el
                    .querySelector('.el-table__body-wrapper')
                    .classList.remove('scrollShow')
            }
        },
        getMapping (data, keys) {
            keys.forEach((ele, ind) => {
                let clone = this._languageTransfer(
                    data.map(i => {
                        if (!i[ele['key']]) {
                            i[ele['key']] = ele['val']
                        }
                        return i[ele['key']]
                    })
                )
                this.appList = this.appList.map((item, index) => {
                    item[ele['key']] = clone[index]
                    return item
                })
            })
        },
        iconFunc (icon) {
            if (icon) {
                return icon
            } else {
                return ``
            }
        },
        maxVersionText ({ maxVersion }) {
            if (maxVersion) {
                return `v${maxVersion}.0`
            } else {
                return `v1.0`
            }
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'letter-spacing: 0.8px;background-color: rgba(51, 51, 51, 0.08);height: 40px;line-height: 40px;color: #333333;'
            }
            if (columnIndex === 0 || columnIndex === 1) {
                // return `cursor: pointer;`
            }
        },
        rowClick (row, event, column) {
        //     console.log(row)
        //     this.$router.push({
        //         name: 'MyProjectsEdit',
        //         params: { appId: row.appId }
        //     })
        //     // this.$store.state.versionHistoryId = row.appId
        //     localStorage.setItem('appId', row.appId)
        },
        cellClick (row, column, cell, event) {
            if (column.property === 'icon' || column.property === 'projectName') {
                this.$router.push({
                    name: 'MyProjectsEdit',
                    params: { appId: row.appId }
                })
                // this.$store.state.versionHistoryId = row.appId
                localStorage.setItem('appId', row.appId)
            }
        },
        cellStyle ({ row, column }) {
            if (column.property === 'icon' || column.property === 'projectName') {
                return `cursor: pointer;`
            }
        },
        momentConversion (row) {
            return moment(row.updatedAt).format('YYYY-MM-DD')
        },
        handleClose () {
            this.dialogVisible = false
        },
        pubMarkets () {
            // const { title, message, status, publishAfterDate } = this
            const apiUri = 'developer/market'
            const apiCfg = apiConfig(apiUri)
            // let body = { ...this.form }

            api.request('get', apiCfg.path, null, null, apiCfg.headers)
                .then(res => {
                    // console.log(res)
                    this.markets = res.data.data.payload
                })
                .catch(error => {
                    console.log(error)
                })
        },
        handleCommand (command) {
            switch (command) {
                case 'application':
                    this.dialogVisible = true
                    // this.$refs['form'].resetFields()
                    console.log(this.$refs['form'])
                    this.form.contentType = command
                    break

                default:
                    // alert(command)
                    break
            }
        },
        createProject () {
            const apiUri = 'developer/app'
            const apiCfg = apiConfig(apiUri)
            let body = { ...this.form }
            // const title = body.projectName
            // delete body.projectName

            api.request('post', apiCfg.path, body, null, apiCfg.headers)
                .then(res => {
                    const appId = res.data.data.id
                    this.dialogVisible = false
                    this.$router.push({
                        name: 'MyProjectsEdit',
                        query: { contentType: this.form.contentType },
                        params: { appId }
                    })
                    // router.push({ name: 'user', params: { userId: 123 }})
                })
                .catch(err => {
                    let errMsg
                    if (err.response && err.response.status !== 200) {
                        errMsg = err.response.data.status.description
                    }
                    this.$alert(errMsg, 'Error', {
                        type: 'error',
                        confirmButtonText: 'OK'
                    })
                })
        },
        submitForm (formName) {
            this.$refs[formName].validate((valid, errObject) => {
                // const groupA = ['title', 'package']
                // const groupB = ['publishSecret', 'mainMarket']
                // let grps = this.showValidateGroup(
                //     [groupA, groupB],
                //     Object.keys(errObject)
                // )
                // console.log(grps)

                if (valid) {
                    this.dialogVisible = false
                    this.createProject()
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        showValidateGroup (grps, errs) {
            let bb = _.map(grps, g => {
                let aa = _.intersectionWith(g, errs, _.isEqual)
                console.log(aa)
                return aa.length > 0
            })
            return bb
        },
        resetForm (formName) {
            this.$refs[formName].resetFields()
            this.dialogVisible = false
        },
        getAppList (type, obj) {
            // document.body.scrollTop = document.documentElement.scrollTop = 0
            this.loading = true
            let apiUri = '/developer/app'
            let status = ''
            let url = ''
            if (type && obj) {
                if (type === 'filter') {
                    let { state, type } = obj
                    status = type
                    url = `?${state.key}=${state.val.toLowerCase()}`
                } else {
                    let { key, val } = obj
                    url = `?${key}=${val.toLowerCase()}`
                }
                apiUri += url
                type === 'search' && this.clearState(type)
            }
            // const { title, message, status, publishAfterDate } = this
            // const apiCfg = apiConfig(apiUri)
            // let body = { ...this.form }
            this._api.request('get', apiUri)
                .then(res => {
                    let keys = [
                        {
                            key: 'maxStatus',
                            val: 'draft'
                        }
                        // ,{
                        //     key: 'notificationMessage',
                        //     val: 'noti'
                        // }
                    ]
                    this.appList = res.data.data.payload
                    // this.appList[0].notificationMessage = '我是一个测试'
                    // this.appList = []
                    // 保证拥有table node
                    !type &&
                        !obj &&
                        !this.appList.length &&
                        (this.isTable = true)
                    !type &&
                        !obj &&
                        this.appList.length &&
                        (this.isTable = false)
                    // this.cloneArray = [].concat(
                    //     JSON.parse(JSON.stringify(res.data.data.payload))
                    // )
                    this.getMapping(res.data.data.payload, keys)
                    if (status) {
                        this.filterStateType(status)
                    }
                    this.loading = false
                    if (this.appList.length || type) {
                        this.isScrollShowFunc(this.appList.length)
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        },
        clearState (type) {
            if (type) {
                this.$store.state.thirdNavigationType = null
                this.$store.state.thirdNavigationState = null
            }
            this.$store.state.thirdNavigationIdentify = null
        },
        filterStateType (type) {
            this.appList = this.appList.filter(
                item => item[type.key] === type.val
            )
        }
    },
    computed: {
        MyProjectsAddState () {
            this.handleCommand(this.$store.state.MyProjectsAddState)
            return this.$store.state.MyProjectsAddState
        },
        thirdNavigationState () {
            return this.$store.state.thirdNavigationState
        },
        thirdNavigationType () {
            return this.$store.state.thirdNavigationType
        },
        thirdNavigationIdentify () {
            let type = this.$store.state.thirdNavigationIdentify
            if (
                type &&
                this.$store.state.isFlagSpanClass === 'MyProjectsList'
            ) {
                if (type === 'search') {
                    this.thirdNavigationSearch &&
                        this.getAppList('search', {
                            key: 'keyword',
                            val: this.thirdNavigationSearch
                        })
                    !this.thirdNavigationSearch && this.getAppList()
                } else {
                    let state = {
                        key: 'status',
                        val: this.thirdNavigationState
                    }
                    let type = {
                        key: 'contentType',
                        val: this.thirdNavigationType
                    }
                    if (this.thirdNavigationState && this.thirdNavigationType) {
                        // 处理两个filter
                        this.getAppList('filter', { state, type })
                    } else if (
                        this.thirdNavigationType &&
                        !this.thirdNavigationState
                    ) {
                        this.getAppList('type', type)
                    } else if (
                        this.thirdNavigationState &&
                        !this.thirdNavigationType
                    ) {
                        this.getAppList('state', state)
                    } else {
                        this.getAppList()
                    }
                }
                this.clearState()
            }
            return this.$store.state.thirdNavigationIdentify
        },
        thirdNavigationSearch () {
            return this.$store.state.thirdNavigationSearch
        }
    },
    watch: {
        dialogVisible () {
            if (!this.dialogVisible) {
                this.$store.state.MyProjectsAddState = null
            }
            return this.dialogVisible
        }
    },
    destroyed () {
        this.clearState('destroyed')
    }
}
</script>
<style lang="scss" scoped>
.cust-dialog {
    .el-input {
        width: 100%;
    }

}
</style>
<style scoped>
/* fu */
* {
    margin: 0px;
}
#appList {
    font-family: sans-serif;
    font-size: 12px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.8px;
    width: 896px;
    margin: auto;
    color: #333333;
}

.tableIconClass {
    width: 60px;
    height: 60px;
    padding: 15px 0px;
    padding-left: 15px;
    padding-right: 10px;
    display: inline-block;
    vertical-align: middle;
}
.maskDivClass {
    width: 100%;
    height: 10px;
    position: absolute;
    /* margin: auto; */
    top: -10px;
    margin-left: -5px;
}
.rightBoxA {
    width: 0;
    height: 0;
    border-width: 0 6px 6px;
    border-style: solid;
    border-color: transparent transparent rgba(51, 51, 51, 0.2);
    margin: 0px auto;
    position: absolute;
    top: -6px;
    left: 46%;
}
.rightBoxAClone {
    width: 0;
    height: 0;
    border-width: 5px 5px 0;
    border-style: solid;
    border-color: rgba(51, 51, 51, 0.2) transparent transparent; /*灰 透明 透明 */
    margin: 0px auto;
    position: absolute;
    bottom: -6px;
    left: 46%;
}
.rightBox {
    width: 0;
    height: 0;
    border-width: 0 5px 5px;
    border-style: solid;
    border-color: transparent transparent #fff;
    margin: 0px auto;
    top: -5px;
    position: absolute;
    left: 47%;
    z-index: 3;
}
.rightBoxClone {
    width: 0;
    height: 0;
    border-width: 5px 5px 0;
    border-style: solid;
    border-color: #fff transparent transparent; /*灰 透明 透明 */
    margin: 0px auto;
    bottom: -5px;
    position: absolute;
    left: 46%;
    z-index: 3;
}
.el-main {
    padding: 193px 0px 66px 0px;
    background: rgba(51, 51, 51, 0.05);
    height: 1210px;
}
.noAppListPosi {
    position: relative;
    width: 500px;
    height: 200px;
    margin: auto;
    margin-top: 70px;
}
.noAppListBoxDiv {
    position: absolute;
    top: 80px;
    right: 173px;
    font-size: 14px;
    text-align: center;
}
.noAppListBoxDiv p {
    margin-bottom: 4px;
}
.noAppListBox {
    /* fu */
    height: 581px;
}
.toolTipBoxText {
    width: 124px;
    font-size: 12px;
    line-height: 1.67;
    letter-spacing: normal;
    font-weight: normal;
    text-align: center;
}
.toolTipBox {
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.15);
    border: 1px solid rgba(0, 0, 0, 0.15);
    position: absolute;
    background: #ffffff;
    z-index: 1;
    padding: 0px 5px 5px 5px;
    border-radius: 4px;
    visibility: hidden;
}
.visibilityClass {
    visibility: visible;
}
.appListBox {
    border-top-left-radius: 8px;
    border-bottom: none;
}
.con-wrapper {
    margin: 0 auto;
}
.statusAppListClass {
    width: 85px;
    border-radius: 4px;
    background-color: rgba(51, 51, 51, 0.1);
    display: block;
    text-align: center;
    line-height: 16px;
    margin-top: 3px;
    color: #333333;
    border: 1px solid rgba(51, 51, 51, 0.3);
    padding: 4px 5px;
}
.statusAppListSuccess {
    background-color: rgba(0, 181, 226, 0.1);
    border: 1px solid #00b5e2;
    color: #00b5e2;
}
.statusAppListFail {
    /* background-color: #ffc44f; */
    /* color: #ffc44f; */
    /* border: 1px solid #ffc44f; */
    border: 1px solid #ffc44f;
    background-color: rgba(255, 196, 79, 0.1);
    color: #f5a623;
}
.el-dropdown {
    vertical-align: top;
}
.el-dropdown + .el-dropdown {
    margin-left: 15px;
}
.el-icon-arrow-down {
    font-size: 12px;
}

.el-input {
    width: 50%;
}
.el-tooltip__popper {
    width: 154px;
    padding: 4px 5px !important;
}
</style>
<style>
.tooltipItem {
    width: 124px;
    padding: 4px 5px !important;
    border: 1px solid #d6d6d6 !important;
    text-align: center;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.15);
    color: #333333;
}
.tooltipItem .popper__arrow {
    border-top-color: #d6d6d6 !important;
    border-bottom-color: #d6d6d6 !important;
}
/*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
#appList ::-webkit-scrollbar {
    width: 10px; /*对垂直流动条有效*/
    height: 10px; /*对水平流动条有效*/
}
/*定义滚动条的轨道颜色、内阴影及圆角*/
#appList ::-webkit-scrollbar-track {
    /* -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); */
    background-color: rgba(51, 51, 51, 0.2);
    border-radius: 3px;
}
/*定义滑块颜色、内阴影及圆角*/
#appList ::-webkit-scrollbar-thumb {
    border-radius: 7px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: rgba(255, 255, 255, 0.8);
}
#appList .scrollShow {
    overflow-y: scroll !important;
    height: 900px;
    overflow-x: hidden !important;
}
#appList .el-table th,
.el-table td {
    padding: 0px;
}
#appList .el-table .cell {
    padding: 0px;
}
#appList .el-table tr:last-child > td {
    border-bottom: none !important;
}
.el-table .sort-caret.ascending {
    border-bottom-color: rgba(51, 51, 51, 0.5) !important;
}
.el-table .sort-caret.descending {
    border-top-color: rgba(51, 51, 51, 0.5) !important;
}
.el-table .ascending .sort-caret.ascending {
}
.el-table .sort-caret.ascending:active{
    border-bottom-color: #00b5e2 !important;
}
.el-table .sort-caret.descending:active{
    border-top-color: #00b5e2 !important;
}
#appList .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: rgba(0, 224, 218, 0.05) !important;
}
#appList .el-table__body {
    overflow: hidden;
}
#appList .el-table__header {
    border-bottom: 1px solid rgba(51, 51, 51, 0.2);
    background-color: rgba(51, 51, 51, 0.1);
}
#appList .el-table--fit {
    border: 1px solid rgba(51, 51, 51, 0.2);
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
}
</style>
